import { render } from "./SpaceFormPageTwo.vue?vue&type=template&id=0a451a8e"
import script from "./SpaceFormPageTwo.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageTwo.vue?vue&type=script&lang=js"
script.render = render

export default script